import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import EmpathySection from './components/EmpathySection';
import MeritSection from './components/MeritSection';
import ReportSection from './components/ReportSection';
import PriceSection from './components/PriceSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import ServiceAreaSection from './components/ServiceAreaSection';
import CampaignSection from './components/CampaignSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';
import SeoJsonLd from './components/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SeoJsonLd />
      <Navbar />
      <HeroSection />
      <EmpathySection />
      <MeritSection />
      <ReportSection />
      <PriceSection />
      <TestimonialsSection />
      <FaqSection />
      <ServiceAreaSection />
      <CampaignSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
